export default "__VITE_ASSET__CWUIXXOx__"